import { ReduxAction } from 'types/redux';
import { actionTypes } from "actions/appInfo/actionTypes";
import { AppInfoState } from "store/types/app-info.types";

const initState: AppInfoState = {
  info: null,
  category: [],
  isSumittingApp: false,
  shouldCloseAppInfo: false,
};

const appInfoReducer = (
  state: AppInfoState = initState,
  action: any
): AppInfoState => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_APP_INFO_SUCCESS:
      return {
        ...state,
        info: payload,
      };
    case actionTypes.UPDATE_APP_INFO_SUCCESS:
      return {
        ...state,
        info: { ...state.info, ...payload },
      };
    case actionTypes.GET_LIST_CATEGORY_SUCCESS:
      return {
        ...state,
        category: payload,
      };
    case actionTypes.SUBMIT_APP:
      return {
        ...state,
        isSumittingApp: true,
      };
    case actionTypes.SUBMIT_APP_SUCCESS:
    case actionTypes.SUBMIT_APP_FAIL:
      return {
        ...state,
        isSumittingApp: false,
      };
    case actionTypes.TOGGLE_APP_INFO_MODAL:
      return {
        ...state,
        shouldCloseAppInfo: payload,
      };
    default:
      return state;
  }
};

export default appInfoReducer;
